import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import decodeToken from "../utils/decodeToken";
import { toast } from "react-toastify";
import NoImg from "../assets/no-image.png";
import "../styles/Navbar.css";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [aboutDropdown, setAboutDropdown] = useState(false);
  const [resourcesDropdown, setResourcesDropdown] = useState(false);
  const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
  const [mobileResourcesOpen, setMobileResourcesOpen] = useState(false);
  const [activeMobileItem, setActiveMobileItem] = useState(null);
  let { user_id, super_admin_id, full_name, avatar_url } = decodeToken();

  const onLogout = () => {
    localStorage.removeItem("loginToken");
    toast.success("Logout successfully");
    window.location.href = "/";
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    const handleClickOutside = (e) => {
      if (!e.target.closest(".user-menu") && !e.target.closest(".hamburger")) {
        setIsDropdownOpen(false);
      }
      if (!e.target.closest(".about-dropdown")) {
        setAboutDropdown(false);
      }
      if (!e.target.closest(".resources-dropdown")) {
        setResourcesDropdown(false);
      }
      if (
        isMenuOpen &&
        !e.target.closest(".mobile-menu") &&
        !e.target.closest(".hamburger")
      ) {
        setIsMenuOpen(false);
        setMobileAboutOpen(false);
        setMobileResourcesOpen(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("click", handleClickOutside);
    };
  }, [isMenuOpen]);

  const closeMenu = () => {
    setIsMenuOpen(false);
    setMobileAboutOpen(false);
    setMobileResourcesOpen(false);
  };

  const handleMobileItemClick = (itemName) => {
    setActiveMobileItem(itemName);
  };

  const isMobile = typeof window !== "undefined" && window.innerWidth < 1270;

  const mobileMenuItemStyle = {
    width: "100%",
    padding: "18px 20px",
    background: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "18px",
    color: "#2a3e4f",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    position: "relative",
    textDecoration: "none",
    marginBottom: 0,
  };
  const mobileMenuItemActiveStyle = {
    ...mobileMenuItemStyle,
    background: "#2a3e4f",
    color: "white",
  };

  // Determine top offset for mobile menu based on screen width
  let mobileMenuTop = 80;
  if (typeof window !== "undefined") {
    if (window.innerWidth >= 769 && window.innerWidth < 1270) {
      mobileMenuTop = 90;
    }
  }

  return (
    <header className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div
        className="navbar-container"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: window.innerWidth > 1270 ? "space-between" : "center",
          width: "90vw",
          maxWidth: "1270px",
          margin: "0 auto",
          gap: window.innerWidth > 1270 ? "30px" : undefined,
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <a href="/" className="navbar-logo" style={{ cursor: "pointer" }}>
            <img src="/shaagird-logo.svg" alt="Logo" />
          </a>
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Donate button for mobile */}
          <button
            className="donate-btn btn mobile-header-donate"
            onClick={() =>
              (window.location.href = "https://donate.shaagird.org/")
            }
            style={{
              display: isMobile ? "flex" : "none",
              alignItems: "center",
              justifyContent: "center",
              height: "35px",
              background: "#251134",
              color: "white",
              border: "1px solid white",
              borderRadius: "20px",
              fontSize: "14px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              width: "100%",
              maxWidth: "140px",
            }}
          >
            Donate
          </button>
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <div
            className={`hamburger${isMenuOpen ? " open" : ""}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            style={{ display: isMobile ? "block" : "none" }}
          >
            <span className="bar" style={{ backgroundColor: "#2a3e4f" }}></span>
            <span className="bar" style={{ backgroundColor: "#2a3e4f" }}></span>
            <span className="bar" style={{ backgroundColor: "#2a3e4f" }}></span>
          </div>
        </div>
        {/* Desktop nav */}
        <nav className={`navbar-links${isMenuOpen ? " open" : ""}`}>
          {/* Mobile menu overlay */}
          {isMenuOpen && isMobile ? (
            <div
              className="mobile-menu"
              style={{
                position: "fixed",
                top: mobileMenuTop,
                left: 0,
                right: 0,
                bottom: 0,
                background: "#2a3e4f",
                display: "flex",
                flexDirection: "column",
                padding: 20,
                zIndex: 1000,
                overflowY: "auto",
                color: "white",
                marginBottom: 30,
              }}
            >
              <div
                className="mobile-menu-content"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                  marginBottom: "30px",
                }}
              >
                <div className="mobile-dropdown">
                  <button
                    style={
                      mobileAboutOpen
                        ? mobileMenuItemActiveStyle
                        : mobileMenuItemStyle
                    }
                    aria-expanded={mobileAboutOpen}
                    onClick={() => {
                      setMobileAboutOpen((v) => !v);
                      handleMobileItemClick("about");
                    }}
                  >
                    <span></span> About
                    <span
                      style={{ position: "absolute", right: 15, fontSize: 14 }}
                    >
                      ▼
                    </span>
                  </button>
                  {mobileAboutOpen && (
                    <div className="mobile-dropdown-menu">
                      <a href="https://about.shaagird.org/our-history/">
                        Our History
                      </a>
                      <a href="https://about.shaagird.org/our-approach/">
                        Our Approach
                      </a>
                      <a href="https://about.shaagird.org/our-team/">
                        Our Team
                      </a>
                      <a href="https://about.shaagird.org/learning-centers/">
                        Learning Centers
                      </a>

                    </div>
                  )}
                </div>
                <div className="mobile-dropdown">
                  <button
                    style={
                      mobileResourcesOpen
                        ? mobileMenuItemActiveStyle
                        : mobileMenuItemStyle
                    }
                    aria-expanded={mobileResourcesOpen}
                    onClick={() => {
                      setMobileResourcesOpen((v) => !v);
                      handleMobileItemClick("resources");
                    }}
                  >
                    <span></span> Resources{" "}
                    <span
                      style={{ position: "absolute", right: 15, fontSize: 14 }}
                    >
                      ▼
                    </span>
                  </button>
                  {mobileResourcesOpen && (
                    <div className="mobile-dropdown-menu">
                      <a
                        href="https://about.shaagird.org/photos/"
                        onClick={closeMenu}
                      >
                        Photos
                      </a>

                      <a
                        href="https://about.shaagird.org/videos/"
                        onClick={closeMenu}
                      >
                        Videos
                      </a>
                      <a
                        href="https://about.shaagird.org/documents/"
                        onClick={closeMenu}
                      >
                        Documents
                      </a>
                      <a
                        href="https://about.shaagird.org/certificates/"
                        onClick={closeMenu}
                      >
                        Certificate
                      </a>
                      <a
                        href="https://about.shaagird.org/reports/"
                        onClick={closeMenu}
                      >
                        Reports
                      </a>

                      <a
                        href="https://about.shaagird.org/policies/"
                        onClick={closeMenu}
                      >
                        Policies
                      </a>
                      <a
                        href="https://about.shaagird.org/financial/"
                        onClick={closeMenu}
                      >
                        Financial
                      </a>
                      <a
                        href="https://about.shaagird.org/accountability/"
                        onClick={closeMenu}
                      >
                        Accountability
                      </a>
                    </div>
                  )}
                </div>
                <a
                  href="/all-kids"
                  onClick={() => handleMobileItemClick("sponsor")}
                  style={
                    activeMobileItem === "sponsor"
                      ? mobileMenuItemActiveStyle
                      : mobileMenuItemStyle
                  }
                >
                  Sponsor
                </a>
                <a
                  href="https://stories.shaagird.org/"
                  onClick={() => handleMobileItemClick("shaagirdnama")}
                  style={
                    activeMobileItem === "shaagirdnama"
                      ? mobileMenuItemActiveStyle
                      : mobileMenuItemStyle
                  }
                >
                  Shaagirdnama
                </a>
                <a
                  href="/sponsored-kids"
                  onClick={() => handleMobileItemClick("sponsored")}
                  style={
                    activeMobileItem === "sponsored"
                      ? mobileMenuItemActiveStyle
                      : mobileMenuItemStyle
                  }
                >
                  Sponsored
                </a>

                <a
                  href="https://cause.shaagird.org/"
                  onClick={() => handleMobileItemClick("causes")}
                  style={
                    activeMobileItem === "causes"
                      ? mobileMenuItemActiveStyle
                      : mobileMenuItemStyle
                  }
                >
                  Causes
                </a>
                {!(user_id || super_admin_id) && (
                  <a
                    href="/login"
                    onClick={() => {
                      closeMenu();
                      handleMobileItemClick("login");
                    }}
                    style={
                      activeMobileItem === "login"
                        ? mobileMenuItemActiveStyle
                        : mobileMenuItemStyle
                    }
                  >
                    Login
                  </a>
                )}
              </div>

              <div className="mobile-auth-section">
                {user_id || super_admin_id ? (
                  <div className="mobile-user-profile">
                    <div className="mobile-user-info">
                      <img
                        src={avatar_url ? avatar_url : NoImg}
                        alt="User Avatar"
                        className="user-avatar"
                      />
                      <span className="user-name">{full_name}</span>
                    </div>
                    <div className="mobile-user-actions">
                      <a
                        href="/mentor-profile-new"
                        onClick={() => {
                          closeMenu();
                          handleMobileItemClick("profile");
                        }}
                        style={
                          activeMobileItem === "profile"
                            ? mobileMenuItemActiveStyle
                            : mobileMenuItemStyle
                        }
                      >
                        Profile
                      </a>
                      <a
                        href="/mentor-profile"
                        onClick={() => {
                          closeMenu();
                          handleMobileItemClick("settings");
                        }}
                        style={
                          activeMobileItem === "settings"
                            ? mobileMenuItemActiveStyle
                            : mobileMenuItemStyle
                        }
                      >
                        Settings
                      </a>
                      <button
                        style={{
                          ...mobileMenuItemStyle,
                          background: "#ff4444",
                          color: "white",
                          marginBottom: "1rem",
                        }}
                        onClick={() => {
                          onLogout();
                          closeMenu();
                        }}
                      >
                        Logout
                      </button>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          ) : (
            // Desktop nav
            <>
              <NavLink to="/" onClick={closeMenu} className="nav-main-link">
                Home
              </NavLink>
              <div
                className="about-dropdown nav-main-link"
                tabIndex={0}
                onMouseEnter={() => setAboutDropdown(true)}
                onMouseLeave={() => setAboutDropdown(false)}
                onFocus={() => setAboutDropdown(true)}
                onBlur={() => setAboutDropdown(false)}
                style={{ position: "relative" }}
              >
                <a
                  href="#about"
                  className="nav-main-link"
                  aria-haspopup="true"
                  aria-expanded={aboutDropdown}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                  }}
                >
                  About
                  <span
                    className="desktop-dropdown-arrow"
                    style={{
                      display: "inline-block",
                      marginLeft: 4,
                      fontSize: 12,
                      transition: "transform 0.2s",
                      transform: aboutDropdown
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  >
                    ▼
                  </span>
                </a>
                {aboutDropdown && (
                  <div className="dropdown-menu about-menu">
                    <a href="https://about.shaagird.org/our-history/">
                      Our History
                    </a>
                    <a href="https://about.shaagird.org/our-approach/">
                      Our Approach
                    </a>
                    <a href="https://about.shaagird.org/our-team/">Our Team</a>
                    <a href="https://about.shaagird.org/learning-centers/">Learning Centers</a>

                  </div>
                )}
              </div>
              <NavLink
                to="/all-kids"
                onClick={closeMenu}
                className="nav-main-link"
              >
                Sponsor
              </NavLink>
              <div
                className="resources-dropdown nav-main-link"
                tabIndex={0}
                onMouseEnter={() => setResourcesDropdown(true)}
                onMouseLeave={() => setResourcesDropdown(false)}
                onFocus={() => setResourcesDropdown(true)}
                onBlur={() => setResourcesDropdown(false)}
                style={{ position: "relative" }}
              >
                <a
                  href="#resources"
                  className="nav-main-link"
                  aria-haspopup="true"
                  aria-expanded={resourcesDropdown}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                  }}
                >
                  Resources
                  <span
                    className="desktop-dropdown-arrow"
                    style={{
                      display: "inline-block",
                      marginLeft: 4,
                      fontSize: 12,
                      transition: "transform 0.2s",
                      transform: resourcesDropdown
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  >
                    ▼
                  </span>
                </a>
                {resourcesDropdown && (
                  <div className="dropdown-menu resources-menu">
                    <a href="https://about.shaagird.org/photos/">Photos</a>


                    <a href="https://about.shaagird.org/videos/">Videos</a>
                    <a href="https://about.shaagird.org/documents/">
                      Documents
                    </a>
                    <a href="https://about.shaagird.org/certificates/">
                      Certificate
                    </a>
                    <a href="https://about.shaagird.org/reports/">Reports</a>

                    <a href="https://about.shaagird.org/policies/">Policies</a>
                    <a href="https://about.shaagird.org/financial/">
                      Financial
                    </a>
                    <a href="https://about.shaagird.org/accountability/">
                      Accountability
                    </a>
                  </div>
                )}
              </div>
              <a
                href="https://stories.shaagird.org/"
                className="nav-main-link nav-shaagirdnama"
              >
                Shaagirdnama
              </a>

              <NavLink
                to="/sponsored-kids"
                onClick={closeMenu}
                className="nav-main-link"
              >
                Sponsored
              </NavLink>

              <a
                href="https://cause.shaagird.org/"
                className="nav-main-link nav-shaagirdnama"
              >
                Causes
              </a>
            </>
          )}
        </nav>
        {/* Desktop user menu */}
        {!isMobile && (
          <div className="desktop-user-section">
            {user_id || super_admin_id ? (
              <div
                className="user-menu"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              >
                <img
                  src={avatar_url ? avatar_url : NoImg}
                  alt="User Avatar"
                  className="user-avatar"
                />
                {isDropdownOpen && (
                  <div className="dropdown-menu">
                    <a href="/mentor-profile-new">Profile</a>
                    <a href="/mentor-profile">Setting</a>
                    <a href="/logout" onClick={onLogout}>
                      Logout
                    </a>
                  </div>
                )}
              </div>
            ) : (
              <a href="/login" className="btn-2">
                Login
              </a>
            )}
            <button
              className="donate-btn btn"
              onClick={() =>
                (window.location.href = "https://donate.shaagird.org/")
              }
            >
              Donate
            </button>
          </div>
        )}
      </div>

      <style jsx>{`
        .mobile-menu {
          position: fixed;
          top: 80px;
          left: 0;
          right: 0;
          bottom: 0;
          background: #2a3e4f;
          display: flex;
          flex-direction: column;
          padding: 20px;
          z-index: 1000;
          overflow-y: auto;
          color: white;
          margin-bottom: 30px;
        }

        .mobile-menu-content {
          display: flex;
          flex-direction: column;
          gap: 15px;
          margin-bottom: 30px;
        }

        .mobile-menu .nav-main-link {
          font-size: 18px;
          padding: 12px 0;
          text-align: left;
          color: white;
          text-decoration: none;
          border-bottom: none;
          transition: all 0.3s ease;
          border-radius: 0;
        }

        .mobile-menu .nav-main-link.active {
          background: #2a3e4f;
          color: white;
        }

        .mobile-dropdown {
          width: 100%;
        }

        .mobile-dropdown-btn {
          width: 100%;
          padding: 12px 15px;
          background: white;
          border: none;
          border-radius: 8px;
          font-size: 18px;
          color: #2a3e4f;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
        }

        .mobile-dropdown-btn span:first-child {
          margin-right: -10px;
        }

        .mobile-dropdown-btn span:last-child {
          position: absolute;
          right: 15px;
          font-size: 14px;
        }

        .mobile-dropdown-btn.active {
          background: #2a3e4f;
          color: white;
        }

        .mobile-dropdown-btn[aria-expanded="true"] span:last-child {
          transform: rotate(180deg);
        }

        .mobile-dropdown-menu {
          display: flex;
          flex-direction: column;
          padding: 10px 0;
          background: #1a2b3c;
          border-radius: 8px;
        }

        .mobile-dropdown-menu a {
          padding: 10px 25px;
          color: white !important;
          display: flex;
          text-align: left;
          text-decoration: none;
          font-size: 16px;
          transition: all 0.3s ease;
        }

        .mobile-dropdown-menu a:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        .mobile-auth-section {
          margin-top: auto;
          padding: 20px 0;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }

        .mobile-user-profile {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 15px;
        }

        .mobile-user-info {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .mobile-user-info .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
        }

        .mobile-user-info .user-name {
          font-size: 16px;
          font-weight: 500;
          color: white;
        }

        .mobile-user-actions {
          display: flex;
          flex-direction: column;
          gap: 10px;
          width: 100%;
        }

        .mobile-profile-link {
          padding: 12px 15px !important;
          width: 100% !important;
          text-align: left;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 8px;
          color: white !important;
          text-decoration: none;
          font-size: 16px;
          transition: all 0.3s ease;
        }

        .mobile-profile-link:hover {
          background: rgba(255, 255, 255, 0.2);
        }

        .mobile-logout-btn {
          padding: 12px 15px;
          width: 100%;
          background: #ff4444;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .mobile-logout-btn:hover {
          background: #cc3333;
        }

        .mobile-auth-buttons {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .mobile-login {
          margin-bottom: 1rem;
          padding: 18px 20px;
          text-align: center;
          background: white;
          color: #2a3e4f;
          border-radius: 8px;
          text-decoration: none;
          font-size: 18px;
          transition: all 0.3s ease;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
          width: 100%;
          border: none;
          cursor: pointer;
          position: relative;
        }

        .mobile-login:hover,
        .mobile-login.active {
          background: #2a3e4f;
          color: white;
        }

        .mobile-donate {
          padding: 12px 15px;
          background: #2a3e4f;
          color: white;
          border: 1px solid white;
          border-radius: 8px;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .mobile-donate:hover {
          background: #1a2b3c;
        }

        /* Hamburger menu styles */
        .hamburger {
          display: none;
          cursor: pointer;
          position: relative;
          width: 30px;
          height: 30px;
          z-index: 1001;
        }

        .bar {
          display: block;
          width: 25px;
          height: 3px;
          margin: 0;
          background-color: #2a3e4f;
          transition: all 0.3s ease;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        }

        .bar:nth-child(1) {
          top: 6px;
        }

        .bar:nth-child(2) {
          top: 13px;
        }

        .bar:nth-child(3) {
          top: 20px;
        }

        /* Hamburger to Cross animation - Fixed positioning */
        .hamburger.open .bar:nth-child(1) {
          top: 13px;
          transform: translateX(-50%) rotate(45deg);
        }

        .hamburger.open .bar:nth-child(2) {
          opacity: 0;
        }

        .hamburger.open .bar:nth-child(3) {
          top: 13px;
          transform: translateX(-50%) rotate(-45deg);
        }

        /* New style for mobile nav buttons (Press, Causes) to match dropdown style but no arrow, white background */
        .mobile-menu .mobile-nav-btn {
          width: 100%;
          padding: 18px 20px;
          background: white;
          border: none;
          border-radius: 8px;
          font-size: 18px;
          color: #2a3e4f;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
          text-decoration: none;
          margin-bottom: 0;
        }

        .mobile-menu .mobile-nav-btn.active {
          background: #2a3e4f;
          color: white;
        }

        /* Updated breakpoint from 900px to 1270px */
        @media (max-width: 1270px) {
          .hamburger {
            display: block;
          }

          .navbar-links {
            display: none;
          }

          .navbar-links.open {
            display: block;
          }

          .desktop-user-section {
            display: none;
          }

          .navbar-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .mobile-header-donate {
            background: #2a3e4f;
            color: white;
            border: 1px solid white;
            border-radius: 8px;
            margin-top: 20px;
            padding: 2px 2px !important;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .mobile-header-donate:hover {
            background: #1a2b3c;
          }

          .mobile-menu .nav-main-link.mobile-nav-btn {
            background: white;
            color: #2a3e4f;
            border-radius: 8px;
            padding: 25px 15px;
            font-size: 18px;
            text-decoration: none;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border: none;
            font-weight: 400;
            transition: all 0.3s ease;
          }

          .mobile-menu .nav-main-link.mobile-nav-btn.active {
            background: #2a3e4f;
            color: white;
          }
          .desktop-dropdown-arrow {
            display: none !important;
          }
        }
        @media (min-width: 1271px) {
          .desktop-dropdown-arrow {
            display: inline-block !important;
            vertical-align: middle;
          }
        }

        /* Additional responsive breakpoints for better tablet experience */
        @media (min-width: 1001px) and (max-width: 1270px) {
          .mobile-menu {
            top: 70px;
            padding: 15px;
          }

          .mobile-menu-content {
            gap: 12px;
          }

          .mobile-dropdown-btn,
          .mobile-menu .mobile-nav-btn {
            padding: 15px;
            font-size: 16px;
          }

          .mobile-dropdown-menu a {
            padding: 8px 20px;
            font-size: 15px;
          }

          .mobile-user-info .user-name {
            font-size: 15px;
          }

          .mobile-profile-link,
          .mobile-logout-btn {
            padding: 10px 12px !important;
            font-size: 15px;
          }
        }

        /* Smaller tablet adjustments */
        @media (min-width: 769px) and (max-width: 1000px) {
          .mobile-menu {
            padding: 12px;
          }

          .mobile-dropdown-btn,
          .mobile-menu .mobile-nav-btn {
            padding: 12px;
            font-size: 15px;
          }

          .mobile-dropdown-menu a {
            padding: 7px 18px;
            font-size: 14px;
          }
        }

        /* Mobile phone adjustments */
        @media (max-width: 480px) {
          .mobile-header-donate {
            width: 25%;
            font-size: 12px;
            height: 32px;
          }

          .mobile-menu {
            padding: 15px;
          }

          .mobile-dropdown-btn,
          .mobile-menu .mobile-nav-btn {
            padding: 14px;
            font-size: 16px;
          }

          .mobile-dropdown-menu a {
            padding: 8px 20px;
            font-size: 14px;
          }
        }

        @media (min-width: 1271px) {
          .desktop-user-section {
            margin-left: 40px;
          }
        }
      `}</style>
    </header>
  );
};

export default Navbar;
